import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Cloud 9 partner configuration schema.
 * Cloud 9 does not use OAuth; the onboarder supplies the practice client ID
 * (provided by Cloud 9 or the practice) and selects which locations to sync.
 */
export const cloud9Schema: PartnerSchemaInternal = {
  partner: 'cloud_9' as PartnerEnum,
  displayName: 'Cloud 9',
  fields: [
    {
      key: 'client_id',
      label: 'Client ID',
      type: 'text',
      required: true,
      helperText:
        'Cloud 9 practice client ID (provided by Cloud 9 or the practice).',
    },
    {
      key: 'locations',
      label: 'Locations',
      type: 'remoteMultiSelect',
      required: false,
      source: 'cloud_9.locations',
      dependsOn: ['client_id'],
      helperText:
        'Select one or more locations to sync. Leave empty to sync all locations.',
    },
  ],
}
